<!--
 * @Author: your name
 * @Date: 2020-05-20 10:15:53
 * @LastEditTime: 2020-07-09 09:11:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue-cli4-multi/src/modules/front/pages/GattTable/components/GattLeft/components/GatttableTd.vue
 -->
<template>
  <div>
    <div
      ref="cells"
      class="cell"
      :data-level="tdData.level"
      :style="{width:th.width ? th.width + 'px' : '80px',textIndent:th.shrink ? tdData.children && tdData.children.length ? (tdData.level - 1) * 10 + 'px' : ((tdData.level - 1) * 10 - 15) + 'px' : null,fontWeight:  'bold' }"
      >
      <span
        style="width: 15px;display: inline-block;text-indent: 0;padding-left: 10px " v-if="th.shrink">
        <span
          v-show="tdData.children"
          @click.stop="opens(tdData)"
          style="cursor: pointer;"
        >
          <i :class="{'el-icon-remove-outline': tdData.open, 'el-icon-circle-plus-outline': !tdData.open}"></i>
        </span>
      </span>
      <template v-if="tdData.level === 2 && (keyValue === 'taskCount' || keyValue === 'demandCount' || keyValue === 'projectCount')">
        <el-tooltip popper-class="popperDom" effect="dark" :content="tdData.params[keyValue]" placement="top">
        <span v-if ="keyValue === 'taskCount'" class="cell-value table_text_click" @click="linkFrom(9, 'tid',tdData.params['taskId'])">{{tdData.params[keyValue]}}</span>
        <span v-if ="keyValue === 'demandCount'" class="cell-value table_text_click" @click="linkFrom(3, 'pid',tdData.params['demandId'])">{{tdData.params[keyValue]}}</span>
        <span v-if ="keyValue === 'projectCount'" class="cell-value table_text_click" @click="linkFrom(11,'proId', tdData.params['projectId'])">{{tdData.params[keyValue]}}</span>
        </el-tooltip>
      </template>
      <template v-else>
        <span v-if="keyValue === 'name' && tdData.params['isOverTime'] === 1" class="cell-value" style="color: red;">{{tdData.params[keyValue]}}</span>
        <span v-else class="cell-value">{{tdData.params[keyValue]}}</span>
      </template>
    </div>
  </div>
</template>
<script>
/* eslint-disable camelcase */
import {getDevOpsSpacePerformanceDetailListApi} from "@/server/tops/devOps";

export default {
  data () {
    return {
      edit: false
    }
  },
  props: {
    tdData: Object,
    th: Object,
    index: Number,
    keyValue: String
  },
  mounted () {
    // console.log(this.tdData)
    // debugger
  },
  methods: {
    // 展开收缩任务
    opens (tdData) {
      //获取报表详情列表
      if(!tdData.open){
        this.$emit('change', tdData)
      }else{
        this.changeOpen(tdData.id, this.$parent.allData)
      }


    },
    getDetailList(uid){
      getDevOpsSpacePerformanceDetailListApi({userId:uid}).then((ret)=>{

      })
    },
    linkFrom(tabid,typeId,busId = ''){
      // let url = `${window.location.origin}/#/devOpsProducerSpace?tabid=${tabid}&${typeId}=${busId}`;
      let url = `${window.location.origin}/devops/space/producer?route=devOpsProducerSpace?tabid=${tabid}&${typeId}=${busId}`;
      window.open(url)
    },
    changeOpen (id, data) {
      for (var i of data) {
        i.open = false;
       /* if (i.id === id) {
          i.open = !i.open
          return
        }
        if (i.children) {
          this.changeOpen(id, i.children)
        }*/
      }
    }
  }
}
</script>
<style>
.cell {
  position: relative;
  word-wrap: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px;
  min-height: 16px;
}
.gante_edit_input_liu {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 1px solid #00b0ff;
  padding: 0 5px;
  font-size: 14px;
  z-index: 1000;
}
.cell-value {
  cursor: default;
  text-indent: 0;
}
.table_text_click {
  text-decoration: underline;
  color: #409EFF;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
